import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { BeeSymbolConcept } from '../components/BeeSymbolConcept';
import { BrandMark } from '../components/BrandMark';
import { brandConcepts } from '../data/brandConcepts';
const DEEP = '#102A2A';
const SAND = '#F5F1E6';

/**
 * Client Review — Revision 01 · bee symbol concepts for approval.
 * Presentation only: nothing here replaces the approved symbol anywhere in the product.
 */
export function BrandConcepts() {
  const navigate = useNavigate();
  return <div className="min-h-screen w-full bg-sand text-deep" data-id="element-2430" data-mp="456ftr3ua6wo">
      <header className="bg-deep text-sand" data-id="element-2431" data-mp="hxmdecdz1cq7">
        <div className="mx-auto max-w-[1200px] px-3 pb-5 pt-4 md:px-5" data-id="element-2432" data-mp="i0ic42xn85fp">
          <button type="button" onClick={() => navigate('/marco2')} className="inline-flex min-h-[44px] items-center gap-1 text-[13px] font-medium text-ondark transition-colors duration-150 ease-brand hover:text-sand" data-id="element-2433" data-mp="d04d1ae0s5tt">
            <ArrowLeftIcon size={16} strokeWidth={1.6} aria-hidden="true" data-id="element-2434" data-mp="2zw2uvxgaqiec" />
            Marco 2
          </button>
          <p className="mt-3 text-[13px] font-medium text-gold" data-id="element-2435" data-mp="34v71qhfr041i">Revisão do cliente · Revisão 01</p>
          <h1 className="mt-1 text-[30px] font-bold leading-[1.1] md:text-[40px]" data-id="element-2436" data-mp="38v7rgy8as1nv">
            Símbolo BEELYV — 3 conceitos de abelha
          </h1>
          <p className="mt-2 max-w-[640px] text-[15px] leading-relaxed text-ondark" data-id="element-2437" data-mp="3iu6qdp39gixo">
            Alternativas para aprovação. O símbolo atual continua aplicado em todo o produto até que um
            conceito seja escolhido; nenhuma tela foi alterada.
          </p>
          <div className="mt-4 flex items-center gap-2 rounded-card border border-sand/10 bg-deeper px-2 py-[12px] sm:inline-flex" data-id="element-2438" data-mp="3ski3o28u44h8">
            <BrandMark size={36} data-id="element-2439" data-mp="5fag4lyegnny" />
            <span className="text-[13px] text-sand" data-id="element-2440" data-mp="5g22r7a0rb23">Símbolo atual (em uso) — referência para comparação</span>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-[1200px] px-3 py-6 md:px-5" data-id="element-2441" data-mp="ac0th1itl55o">
        <ul className="grid gap-3 lg:grid-cols-3" data-id="element-2442" data-mp="26i1iu5hs2a45">
          {brandConcepts.map(concept => <li key={concept.id} data-id="element-2443" data-mp="21jqbq2ivadpm">
              <article className="flex h-full flex-col overflow-hidden rounded-panel border border-sand-line bg-white shadow-card" data-id="element-2444" data-mp="21gkkagmrmzqq">
                <div className="grid grid-cols-2" data-id="element-2445" data-mp="2bg34my6l8njb">
                  <div className="grid aspect-square place-items-center bg-deep" data-id="element-2446" data-mp="2bei5ev9bwgf4">
                    <BeeSymbolConcept concept={concept.id} size={112} surface={DEEP} data-id="element-2447" data-mp="2p6evktrfsg8v" />
                  </div>
                  <div className="grid aspect-square place-items-center bg-sand" data-id="element-2448" data-mp="2l64rxnr4a1x6">
                    <BeeSymbolConcept concept={concept.id} size={112} surface={SAND} data-id="element-2449" data-mp="2z5nkv9bcx6ow" />
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-3" data-id="element-2450" data-mp="2u59paqqxzp7r">
                  <h2 className="text-section text-deep" data-id="element-2451" data-mp="14sxswx4ju7k5">{concept.name}</h2>
                  <p className="mt-1 text-[13px] leading-relaxed text-muted" data-id="element-2452" data-mp="ztuxm4edffpd">{concept.idea}</p>
                  <ul className="mt-2 space-y-[2px]" data-id="element-2453" data-mp="3bfvgeirj8xp4">
                    {concept.strengths.map(item => <li key={item} className="flex items-center gap-1 text-[12.5px] text-deep" data-id="element-2454" data-mp="3gegeabjbb5ae">
                        <span className="h-[6px] w-[6px] shrink-0 rounded-pill bg-gold" aria-hidden="true" data-id="element-2455" data-mp="31pk9qoggsaej" />
                        {item}
                      </li>)}
                  </ul>

                  <div className="mt-auto pt-3" data-id="element-2456" data-mp="2sp48lln71fcu">
                    <p className="text-[11px] font-medium text-muted" data-id="element-2457" data-mp="2xp0ejqfgbgv1">Tamanhos de ícone do app</p>
                    <div className="mt-1 flex items-end gap-2" data-id="element-2458" data-mp="2irr6tm5uc0h5">
                      {[56, 32, 16].map(px => <div key={px} className="flex flex-col items-center gap-[4px]" data-id="element-2459" data-mp="2nqasrmkfpc9i">
                          <span className="grid place-items-center bg-deep" style={{
                      width: px,
                      height: px,
                      borderRadius: px * 0.24
                    }} data-id="element-2460" data-mp="h0mfkr7tl1xc">
                            <BeeSymbolConcept concept={concept.id} size={Math.round(px * (px <= 16 ? 0.9 : 0.72))} surface={DEEP} data-id="element-2461" data-mp="2i2vpxp7nouaw" />
                          </span>
                          <span className="bee-num text-[10px] text-muted" data-id="element-2462" data-mp="24331y1niks6m">{px}px</span>
                        </div>)}
                    </div>
                  </div>
                </div>
              </article>
            </li>)}
        </ul>

        <p className="mt-4 max-w-[720px] text-[12.5px] leading-relaxed text-muted" data-id="element-2463" data-mp="1ub6sjufz9fn3">
          Os conceitos são propostas de direção. Após a escolha, o símbolo aprovado será refinado e entregue
          como vetor oficial (versões principal, clara, escura, outline e favicon) antes de substituir o
          símbolo atual no produto.
        </p>
      </main>
    </div>;
}